import { Button, Card, Col, Collapse, Container, Form, Modal, Row, Stack, Tab, Tabs } from "react-bootstrap";
import styles from "./QuejasSugerencias.module.css";
import { useEffect, useState } from "react";
import { Queja, RegistrarQuejaRest_Entrada, RegistrarQuejaRest_Parametros, RegistrarQuejaRest_Respuesta, builtRegistrarQuejaRest_Entrada } from "../Commons/Services/RegistrarQuejaRest";
import { ConsultaWS } from "../Commons/ServiciosBase";
import { RegistrarSugerenciaRest_Entrada, RegistrarSugerenciaRest_Parametros, RegistrarSugerenciaRest_Respuesta, Sugerencia, builtRegistrarSugerenciaRest_Entrada } from "../Commons/Services/RegistrarSugerenciaRest";
import Loading from "../General/Loading";
import ConfirmMessage from "../General/ConfirmMessage";
import Encuesta from "./Encuesta";
import { ConsultarQuejasRequest, ConsultarQuejasResponse, getDataService_ConsultarQuejas } from "../Commons/serviciosMySkyUI/ConsultarQuejas.Payload";
import { invokeQuejasSugService } from "../Commons/serviciosMySkyUI/HistorialQuejasSug.Service";
import { ConsultarSugerenciasRequest, ConsultarSugerenciasResponse, getDataService_ConsultarSugerencias } from "../Commons/serviciosMySkyUI/ConsultarSugerencias.Payload";
import { AltaSolicitudServicioRequest, SolicitudServicio, getDataService_AltaSolicitudServicio } from "../Commons/serviciosMySkyUI/SolicitudGenerarQueja.Payload";
import { invokeSolicitudGenerarQueja } from "../Commons/serviciosMySkyUI/SolicitudGenerarQueja.Service";
import { GeneraQuejaRequest, GeneraSugerenciaRequest, getDataService_EnviarQueja, getDataService_EnviarSugerencia } from "../Commons/serviciosMySkyUI/GenerarQueja.Payloads";
import { invokeGeneraQueja } from "../Commons/serviciosMySkyUI/GeneraQueja.Service";
import { DoDateServices } from "../Commons/serviciosMySkyUI/Services.Interface";
import flecha from "../../src/assets/img/Iconos/flechaAbajo.svg";

const QuejasSugerencias = () => {
  const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));

  const [cuenta, setCuenta] = useState(sessionStorage.getItem("cuenta"));
  const [active, setActive] = useState("quejas");
  const [activeHist, setActiveHist] = useState("histQuejas");
  const [validaDescripcion, setValidaDescripcion] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [validaDescripcionLong, setValidaDescripcionLong] = useState(false);
  const [desactiva, setDesactiva] = useState(false);
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [loading, isLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [quejasHist, setQuejasHist] = useState<any>([]);
  const [sugerenciasHist, setSugerenciasHist] = useState<any>([]);
  const [indicesQuejas, setIndicesQuejas] = useState<any>([]);
  const [indicesSugerencias, setIndicesSugerencias] = useState<any>([]);

  function handleClick(key: string) {
    setActive(key);
  }

  function handleClickHist(key: string) {
    setActiveHist(key);
  }

  function manejaCollapseQuejas(key: number) {
    setIndicesQuejas(
      indicesQuejas.map((e: any) =>
        e.id === key? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
      )
    );
  }

  function manejaCollapseSugerencias(key: number) {
    setIndicesSugerencias(
      indicesSugerencias.map((e: any) =>
        e.id === key? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
      )
    );
  }

  const handleShow = () => {
    setShowModal(true);
  };

  const valida = (e: any) => {

    let regExLetras = /^(?!\s)[0-9A-Za-zñáéíóúÁÉÍÓÚ\s,.]+$/; //solo para letras y espacios

    setDescripcion(e);
    e.length === 100 ? setValidaDescripcionLong(true) : setValidaDescripcionLong(false);
    regExLetras.test(e) === false ? setValidaDescripcion(true) : setValidaDescripcion(false);

  }

  const formatoFecha = (fecha: string) => {
    let ar = [];
    let f = "";

    if (fecha !== null) {
      ar = fecha.split("-");
      f = ar[2] + "/" + ar[1] + "/" + ar[0];
    }

    return f;
  };

  const generaReporte = async (valueActive:string) => {
    
    valueActive = valueActive === "sugerencias" ? "sugerencia" : valueActive;


    if (descripcion !== "" && validaDescripcion === false && validaDescripcionLong === false) {
      isLoading(true);
      let description = valueActive.charAt(0).toUpperCase() + valueActive.slice(1) + ": " + descripcion; //revisar este campo para limpiarlo
      let solicitudServicio : SolicitudServicio = {
        Cuenta: sessionStorage.getItem("cuenta")!,
        Area: "Web",
        SubArea: "Otros servicios",
        Descripcion: description,
        ContactoRowId: sessionStorage.getItem("RowIdContacto")!,
        MailConfirmacion: sessionStorage.getItem("Usuario")!,
        Pais: sessionStorage.getItem("pais")!,
        TipoCuenta: sessionStorage.getItem("TipoCuenta")!,
        NombreSuscriptor: sessionStorage.getItem("NombreSuscriptor")!,
        Sistema: "HIJUMP",
        idSesion: sessionStorage.getItem("idSesion")!,
        ContratacionServicios: {PaqueteActual:sessionStorage.getItem("Paquete")!, NombreCanalALaCarta:sessionStorage.getItem("CanalALaCarta")!, PenalizacionVETVCA:sessionStorage.getItem("PenalizacionVETVCA")!},
      }

      let requestGenerarSolicitudQueja : AltaSolicitudServicioRequest = {
        SolicitudDeServicio: solicitudServicio
      };

      const generarSolicitudQuejaPayload = getDataService_AltaSolicitudServicio(requestGenerarSolicitudQueja);

      let { resp, errorService } = await invokeSolicitudGenerarQueja(generarSolicitudQuejaPayload);

      if(resp?.resultado === "0"){
          if(active === "quejas"){
            await sendQueja(resp.NumeroSolicitud);
          }else{
            await sendSugerencia(resp.NumeroSolicitud);
          }
      }
      setDescripcion("");
      isLoading(false);

    }else{
        setStatus("ERROR");
        setMessage("Información faltante o errónea");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
    }


  }//fin de generaReporte

  

  const sendQueja = async(NumeroSS : string) => {
    let request : GeneraQuejaRequest = {
      userID:  sessionStorage.getItem("cuenta")! + "-01",
      TipoConsulta: "1",
      Numero_SS: NumeroSS,
      Quejas: descripcion,
      accountNumber:`${flujo === "Sky+"
        ? sessionStorage.getItem("cuenta")!
        : sessionStorage.getItem("cuenta")! ?? ""}`
    }

    const generaQueja = getDataService_EnviarQueja(request);

    let { resp, errorService } = await invokeGeneraQueja(generaQueja);
	
    if (resp) {

      setStatus("OK");
      setMessage(resp.respuestadesc);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      setHistQuejas();
    }
    isLoading(false);
  }

  const sendSugerencia = async(NumeroSS : string) => {
    let request : GeneraSugerenciaRequest = {
      userID: sessionStorage.getItem("cuenta")! + "-01",
      TipoConsulta: "1",
      NumeroSS: NumeroSS,
      Sugerencias: descripcion
    }

    const generaQueja = getDataService_EnviarSugerencia(request);

    
    let { resp, errorService } = await invokeGeneraQueja(generaQueja);
	
    if (resp) {


      setStatus("OK");
      setMessage(resp.respuestadesc);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      setHistSugerencias();
    }
    isLoading(false);
  }

    // Obtiene las Quejas registradas y las asigna a rowsHistQuejas
    const setHistQuejas = async () => {

      // Inicializa request
      const consultarQuejasReq: ConsultarQuejasRequest = {
        userID: (sessionStorage.getItem("cuenta") + "-01"),
        TipoConsulta: "2", // Por las pruebas que hice, en realidad podría ser cualquier número
        accountNumber:`${flujo === "Sky+"
          ? sessionStorage.getItem("cuenta")!
          : sessionStorage.getItem("cuenta")! ?? ""}`
      };
  
      // Inicializa payload
      const consultarQuejasPayload = getDataService_ConsultarQuejas(consultarQuejasReq);

      
      // Invoca servicio
      let { dataResponse, errorService } = await invokeQuejasSugService(consultarQuejasPayload);
  
      // Una vez que se invoco el servicio, dataResponse ya tiene un valor
      if (dataResponse) {

        const consultarQuejasRes: ConsultarQuejasResponse = dataResponse.completResponse;
        setQuejasHist(consultarQuejasRes.Quejas);

        let arreglo = consultarQuejasRes.Quejas;
        let arTemp:any = [];
        if (arreglo?.length) {
          arreglo.forEach((item, index)=>{
            arTemp.push({id:index, isOpen:false});
          });
        }

        setIndicesQuejas(arTemp);


        
      }
      else {
        // Si ya se recuperó la respuesta del servicio
        if (errorService) {
          console.error("No se recuperó respuesta del servicio");
          console.error("error recuperado al ejecutar el servicio REST :::");
          console.error(errorService.code, "  - ", errorService.messageError);
        }
      }
    }//fin de setHistQuejas
  
    // Obtiene las Sugerencias registradas y las asigna a rowsHistSugerencias
    const setHistSugerencias = async () => {
  
      // Inicializa request
      const consultarSugReq: ConsultarSugerenciasRequest = {
        userID: (sessionStorage.getItem("cuenta") + "-01"),
        TipoConsulta: "2", // Por las pruebas que hice, en realidad podría ser cualquier número
      };
  
      // Inicializa payload
      const consultarSugPayload = getDataService_ConsultarSugerencias(consultarSugReq);

      
      // Invoca servicio
      let { dataResponse, errorService } = await invokeQuejasSugService(consultarSugPayload);
  
      // Una vez que se invoco el servicio, dataResponse ya tiene un valor
      if (dataResponse) {

        const consultarSugRes: ConsultarSugerenciasResponse = dataResponse.completResponse;
        setSugerenciasHist(consultarSugRes.Sugerencias);

        
        let arreglo = consultarSugRes.Sugerencias;
        let arTemp:any = [];
        if (arreglo?.length) {
          arreglo.forEach((item, index)=>{
            arTemp.push({id:index, isOpen:false});
          });
        }

        setIndicesSugerencias(arTemp);

      }
      else {
        // Si ya se recuperó la respuesta del servicio
        if (errorService) {
          console.error("No se recuperó respuesta del servicio");
          console.error("error recuperado al ejecutar el servicio REST :::");
          console.error(errorService.code, "  - ", errorService.messageError);
        }
      }
      
    }

    useEffect(() => {
      setHistQuejas();
      setHistSugerencias();

    }, []);

  return (
    <>
      <Loading isLoading={loading} />
      <Row className={styles["alertContainer"]}>
        <Col className={styles["messageStyle"]}>
          <ConfirmMessage status={status} message={message} showAlert={showAlert} />
        </Col>
      </Row>
      <Container className={styles.contenedor}>

          <Row>
            <Col className={styles["tabContainer"]}>

              <div id="big" className="d-none d-xl-block d-lg-block ">
                <Tabs id="videoTab" className={styles["divTabs"]} onSelect={(key) => handleClick(key!)} defaultActiveKey={"quejas"}>
                  <Tab tabClassName={
                      active === "quejas"
                        ? styles["divTabsActive"] + " " + styles["tabVideo"]
                        : styles["tabVideo"]
                    }
                    eventKey={"quejas"} title={"Realizar una queja"} key={"quejas"} ></Tab>

                  <Tab tabClassName={
                      active === "sugerencias"
                        ? styles["divTabsActive"] + " " + styles["tabVideo"]
                        : styles["tabVideo"]
                    }
                    eventKey={"sugerencias"} title={"Realizar una sugerencia"} key={"sugerencias"}></Tab>
                </Tabs>
              </div>

              <div id="small" className="d-lg-none d-xl-none">
              <Tabs id="videoTab" className={styles["divTabs"]} onSelect={(key) => handleClick(key!)} defaultActiveKey={"quejas"}>
                <Tab tabClassName={
                    active === "quejas"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"quejas"} title={"Queja"} key={"quejas"} ></Tab>
                
                <Tab tabClassName={
                    active === "sugerencias"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"sugerencias"} title={"Sugerencia"} key={"sugerencias"}></Tab>
              </Tabs>
              </div>              

            </Col>
          </Row>
          <Row className={styles["subheaderRowCampos"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} >
            <Form className={styles["form"]}>
                <Form.Group>
                  <Form.Label><span style={{color:"red"}}>*{' '}</span>Descripción
                    {validaDescripcion ? <span style={{color:"red"}}>{' '}(Sólo texto)</span> : <span></span>}
                    {descripcion.length > 200 ? <span style={{color:"red"}}>{' '}(Máximo 200 carácteres)</span> : <span></span>}
                  </Form.Label>
                  <Form.Control maxLength={201} as="textarea" rows={3} onChange={(e) => valida(e.target.value)} value={descripcion}
                    style={{ resize: 'none' }} />
                </Form.Group>
                <br/>
                <Button className={styles.button} onClick={() => generaReporte(active)} disabled={desactiva}>
                  {active === "quejas"?
                    <div className="botonreportar">Realizar queja</div>
                    :
                    <div className="botonreportar">Realizar sugerencia</div>
                  }
                </Button>
              </Form>

            </Col>
          </Row>

          <Row>
                <Col>
                    <h3 className={styles.subtituloPaginaIntermedio}>Tu opinión nos interesa</h3>                
                </Col>
            </Row>     
            <Row>
                <Col>
                    <p className={styles.textoPaginaIntermedio}>Completa la encuesta y ayúdanos a mejorar</p>                
                </Col>
            </Row>  
            <Row>
                <Col className={styles.AlineaButtonIntermedio}>
                 <Button className={styles.button} onClick={handleShow}>Completar encuesta</Button>
                </Col>
            </Row> 

            <Encuesta apertura={showModal} manejaApertura={setShowModal}/>

            <Row>
                <Col className={styles.colSubtituloPaginaInferior}>
                    <h3 className={styles.subtituloPaginaInferior}>Tu historial de quejas y sugerencias</h3>                
                </Col>
            </Row> 

            <div id="big" className="d-none d-xl-block d-lg-block ">
            <Row>
            <Col className={styles["tabContainer"]}>
              <Tabs id="videoTab" className={styles["divTabsHist"]} onSelect={(key) => handleClickHist(key!)} defaultActiveKey={"histQuejas"}>
                <Tab tabClassName={
                    activeHist === "histQuejas"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"histQuejas"} title={"Historial de quejas"} key={"histQuejas"} >

                  <Container fluid className={styles["subheaderRowGrid"] + " " + styles["historialGrid"]}>
                  {quejasHist && quejasHist.length > 0?
                    (<Row
                      className={styles["subheaderRowGrid"] + " " + styles["gridHeader"]}
                    >
                      <Col xs={2} sm={2} md={2} lg={3} xl={2}>
                        <span>Fecha</span>
                      </Col>
                      <Col xs={2} sm={2} md={2} lg={9} xl={10}>
                        <span>Queja</span>
                      </Col>

                    </Row>):<></>}
                    {quejasHist && quejasHist.length > 0?
                    (quejasHist.map((item: any, index: number) => (
                        <Row
                          className={styles["subheaderRowGrid"] + " " + styles["grid"]}
                          key={index}
                        >
                          <Col xs={2} sm={2} md={2} lg={3} xl={2} className={styles["alignToLeft"]}>
                            <span>{formatoFecha(item.Fecha.slice(0, 10))}</span>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={9} xl={10} className={styles["alignToLeft"]}>
                            <span>{item.Queja}</span>
                          </Col>

                        </Row>
                      ))):
                      <h4 className={styles["avisoHistorial"]}>No hay quejas, cuando realices una aparecerá aquí.</h4>
                    }
                  </Container>

                  </Tab>
                
                <Tab tabClassName={
                    activeHist === "histSugerencias"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"histSugerencias"} title={"Historial de sugerencias"} key={"histSugerencias"}>

                  <Container fluid className={styles["subheaderRowGrid"] + " " + styles["historialGrid"]}>

                    {sugerenciasHist && sugerenciasHist.length > 0?
                    (<Row className={styles["subheaderRowGrid"] + " " + styles["gridHeader"]}>
                      <Col xs={2} sm={2} md={2} lg={3} xl={2}>
                        <span>Fecha</span>
                      </Col>
                      <Col xs={2} sm={2} md={2} lg={9} xl={10}>
                        <span>Sugerencia</span>
                      </Col>

                    </Row>):<></>}


                    {sugerenciasHist && sugerenciasHist.length > 0?
                    (sugerenciasHist.map((item: any, index: number) => (
                        <Row
                          className={styles["subheaderRowGrid"] + " " + styles["grid"]}
                          key={index}
                        >
                          <Col xs={2} sm={2} md={2} lg={3} xl={2} className={styles["alignToLeft"]}>
                            <span>{formatoFecha(item.REGISTRATION_DATE.slice(0, 10))}</span>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={9} xl={10} className={styles["alignToLeft"]}>
                            <span>{item.SUGGESTION}</span>
                          </Col>

                        </Row>
                      ))):
                      <h4 className={styles["avisoHistorial"]}>No hay sugerencias, cuando realices una aparecerá aquí.</h4>
                    }
                  </Container>

                  </Tab>
              </Tabs>
            </Col>
          </Row>
        </div>




        {/***************************** 
          inicia seccion para responsivo 
          *******************************/}
        <div id="small" className="d-lg-none d-xl-none">

        <Row>
            <Col className={styles["tabContainerSmall"]}>
              <Tabs id="videoTab" className={styles["divTabsHist"]} onSelect={(key) => handleClickHist(key!)} defaultActiveKey={"histQuejas"}>
                <Tab tabClassName={
                    activeHist === "histQuejas"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"histQuejas"} title={"Quejas"} key={"histQuejas"} >

                  <Container className={styles["contenedorSmall"]}>
                  {quejasHist && quejasHist.length > 0?
                    (quejasHist.map((item: any, index:number) => (
                        <Card className={styles["cardSmall"]} >
                          <Row>
                            <Col className={styles["headerCard"]}>
                              <p className={styles["navegaSmall"]}><b>{formatoFecha(item.Fecha.slice(0, 10))}</b></p>
                            </Col>
                            <Col>
                              <span>
                                <Button
                                  style={{ background: "white",border: "none",float: "right"}} onClick={() => manejaCollapseQuejas(index)} >
                                  <img src={flecha} aria-controls="example-collapse-text" aria-expanded={indicesQuejas[index].isOpen}
                                      className={ indicesQuejas[index].isOpen === true? styles["rota"]: styles["noRota"]}/>
                                </Button>
                              </span>
                            </Col>
                          </Row>
                          <Collapse in={indicesQuejas[index].isOpen}>
                            <div id="example-collapse-text" className={styles["infoCardSmall"]}>
                              <p className={styles["subtituloInfo"]}><b>Fecha</b></p>
                              <p className={styles["infoCollapse"]}>{formatoFecha(item.Fecha.slice(0, 10))}</p>
                              <p className={styles["subtituloInfo"]}><b>Queja</b></p>
                              <p className={styles["infoCollapse"]}>{item.Queja}</p>
                            </div>
                          </Collapse>
                        </Card>
                      ))):
                      <h4 className={styles["avisoHistorial"]}>No hay quejas, cuando realices una aparecerá aquí.</h4>
                    }
                  </Container>

                  </Tab>
                
                <Tab tabClassName={
                    activeHist === "histSugerencias"
                      ? styles["divTabsActive"] + " " + styles["tabVideo"]
                      : styles["tabVideo"]
                  }
                  eventKey={"histSugerencias"} title={"Sugerencias"} key={"histSugerencias"}>

                    <Container className={styles["contenedorSmall"]}>
                    {sugerenciasHist && sugerenciasHist.length > 0?
                      (sugerenciasHist.map((item: any, index:number) => (
                          <Card className={styles["cardSmall"]}>
                            <Row>
                              <Col className={styles["headerCard"]}>
                                <p className={styles["navegaSmall"]}><b>{formatoFecha(item.REGISTRATION_DATE.slice(0, 10))}</b></p>
                              </Col>
                              <Col>
                                <span>
                                  <Button
                                    style={{ background: "white",border: "none",float: "right"}} onClick={() => manejaCollapseSugerencias(index)} >
                                    <img src={flecha} aria-controls="example-collapse-text" aria-expanded={indicesSugerencias[index].isOpen}
                                         className={ indicesSugerencias[index].isOpen === true? styles["rota"]: styles["noRota"]}/>

                                  </Button>
                                </span>
                              </Col>
                            </Row>
                            <Collapse in={indicesSugerencias[index].isOpen}>
                              <div id="example-collapse-text" className={styles["infoCardSmall"]}>
                                <p className={styles["subtituloInfo"]}><b>Fecha</b></p>
                                <p className={styles["infoCollapse"]}>{formatoFecha(item.REGISTRATION_DATE.slice(0, 10))}</p>
                                <p className={styles["subtituloInfo"]}><b>Sugerencia</b></p>
                                <p className={styles["infoCollapse"]}>{item.SUGGESTION}</p>
                              </div>
                            </Collapse>
                          </Card>
                        ))):
                        <h4 className={styles["avisoHistorial"]}>No hay sugerencias, cuando realices una aparecerá aquí.</h4>
                      }
                    </Container>
                  

                  </Tab>
              </Tabs>
            </Col>
          </Row>



        
          
        </div>
      </Container>
      
    </>
  );
};

export default QuejasSugerencias;